import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	// eslint-disable-next-line
	
	const __default__ = { name: 'VDialogActions' } // name the component
  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ""
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(clsx)(__props.className, 'mt-8 flex flex-col-reverse items-center justify-end gap-3 *:w-full sm:flex-row sm:*:w-auto'))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})